import {
	useLoaderData,
	useLocation,
	useNavigate,
	useNavigation,
} from '@remix-run/react'
import PlentyBody from '#app/components/typography/plenty-body'
import { Checkbox } from '#app/components/ui/checkbox'
import { Label } from '#app/components/ui/label'
import { type ClerkFacet } from '#app/constants/clerk-api'
import { type loader } from '#app/routes/_public+/products+/$slug'
import { subtractArrays } from '#app/utils/array-utils'

export function MaterialsSelection() {
	const data = useLoaderData<typeof loader>()
	const location = useLocation()
	const navigate = useNavigate()
	const navigation = useNavigation()
	const materialsFacets = data.facetsData?.facets?.materials as ClerkFacet[]

	const handleCheckboxChange = (
		checked: boolean,
		term: string[],
		key: string,
	) => {
		const params = new URLSearchParams(
			navigation.state === 'idle'
				? location.search
				: navigation.location.search,
		)
		if (checked) {
			// I need to add the current term and also the unisex term
			term.forEach(value => params.append(key, value))
		} else {
			const values = params.getAll(key)
			const newValues = subtractArrays(values, term)
			params.delete(key)
			newValues.forEach(value => {
				params.append(key, value)
			})
		}
		// remove the pagination
		params.delete('p')
		navigate({
			pathname: '.',
			search: params.toString(),
		})
	}

	return (
		<div className="flex flex-col space-y-2">
			{materialsFacets?.map((facet: ClerkFacet) => (
				<Label
					htmlFor={facet.value}
					className="flex items-center hover:cursor-pointer"
					key={facet.name}
				>
					<Checkbox
						className="mr-2 h-6 w-6 "
						id={facet.value}
						value={facet.value}
						name="size"
						defaultChecked={new URLSearchParams(
							navigation.state === 'idle'
								? location.search
								: navigation.location.search,
						)
							.getAll('materials')
							.includes(facet.value)}
						onCheckedChange={checked =>
							handleCheckboxChange(checked, [facet.value], 'materials')
						}
					/>

					<div className="flex w-full justify-between gap-2">
						<PlentyBody size="sm">{facet.value}</PlentyBody>
						<PlentyBody size="sm" className="text-green-40">
							{facet.count}{' '}
						</PlentyBody>
					</div>
				</Label>
			))}
		</div>
	)
}
